<template>
  <div class="radio-group">
    <label :key="option.value" v-for="option in options" class="radio-item" v-bind:class="{ 'is--active': model == option.value }">
            <input v-model="model"  type="radio" :id="option.value"
                   :name="name" :value="option.value" />
            <div class="icon">
                <img :src="option.image" height="70" />
            </div>
            <span :for="option.value">{{ option.label }}</span>
    </label>
  </div>
</template>

<script>
export default {
  name: 'NumberInput',
  props: ['images', 'values', 'setter', 'name', 'labels'],
  computed: {
    options () {
      const values = this.values.split(',')
      const images = this.images.split(',')
      const labels = this.labels.split(',')
      let options = []
      for (var i = 0; i < values.length; i++) {
        options.push({ value: values[i], label: labels[i], image: images[i] })
      }
      return options
    },
    model: {
      get () {
        return this.$store.state.variables[this.name]
      },
      set (value) {
        this.$store.commit(this.setter, value)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/helpers/radio-select.vue